/**
 * Container for filters that have been applied
 */
import React from 'react'
import ComboFilter from './ComboFilter.jsx'

const AppliedFilters = ({ filtersList, appliedList, filterChanged, filterRemoved }) => {
  return (
    <div className='mt-4 mb-2'>
      <header className='mx-2'>Applied filters<span className='filters-badge'>{appliedList.length}</span></header>
      {
        appliedList.map((applied, idx) => {
          return (
            <ComboFilter
              data={applied}
              filtersList={filtersList}
              disabled // attr type should not be changed to another type (can cause confusion)
              filterChanged={filterChanged}
              filterRemoved={filterRemoved(applied.id)}
              type='applied'
              key={applied.id}
            />
          )
        })
      }
    </div>
  )
}

export default AppliedFilters
